const labels = {
  openNavigation: ['展开导航', '展開導覽', 'Open navigation'],
  closeNavigation: ['关闭导航', '關閉導覽', 'Close navigation'],
  navigation: ['管理导航', '管理導覽', 'Admin navigation'],
  filters: ['筛选与查询', '篩選與查詢', 'Search and filters'],
  filtered: ['已筛选', '已篩選', 'Filtered'],
  scrollTable: ['左右滑动查看完整表格', '左右滑動查看完整表格', 'Swipe horizontally to see all columns']
}
export function mobileUiText(locale, key) {
  const index = /^en/i.test(locale) ? 2 : /Hant|TW|HK|MO/i.test(locale) ? 1 : 0
  return labels[key][index]
}
